<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import SmartCampaignForm from './SmartCampaignForm.vue';

const emit = defineEmits(['submit']);

const { t } = useI18n();

const dialogRef = ref(null);
const formRef = ref(null);

const isSubmitDisabled = computed(() => formRef.value?.isSubmitDisabled);

const handleSubmit = async () => {
  const details = await formRef.value?.handleSubmit();
  if (details) {
    emit('submit', details);
    formRef.value?.resetState();
    dialogRef.value?.close();
  }
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="t('SMART_CAMPAIGNS.CREATE.TITLE')"
    :disable-confirm-button="isSubmitDisabled"
    :confirm-button-label="t('SMART_CAMPAIGNS.CREATE.BUTTONS.CREATE')"
    :cancel-button-label="t('SMART_CAMPAIGNS.CREATE.BUTTONS.CANCEL')"
    width="6xl"
    overflow-y-auto
    @confirm="handleSubmit"
  >
    <SmartCampaignForm ref="formRef" />
  </Dialog>
</template>
